// js
import { connect } from 'react-redux';
import { makeGetConfiguredItemCorrelations } from '../../selectors/dsa/sourcesSelectors';
import ConfiguredItemForm from '../../components/sources/ConfiguredItemForm';


const mapStateToProps = (state, props) => {
  const getConfiguredItemCorrelations = makeGetConfiguredItemCorrelations();
  return {
    correlationCategories: getConfiguredItemCorrelations(state, props)
  };
};

const mapDispatchToProps = () => {
  return {};
};

export default connect(mapStateToProps, mapDispatchToProps)(ConfiguredItemForm);



// WEBPACK FOOTER //
// ./src/containers/sources/ConfiguredItemForm.js